/**
 * NOTE: The design and copy of our cookie banners has been fixed and approved by our legal team.
 *       Please reach out to one of our product counsels if you need to modify it in any way.
 */

import React from 'react'
import dismissIcon from '@web/ui-platform/images/icon-32-x.svg'

import initialOptions, { type ConsentRegion } from 'lib/initial_options'
import { AnchorElementTracked } from 'shared/components/forms/basic_form/basic_form'
import { DEPRECATED_BrandButton } from 'shared/components/forms/landing_form/landing_form'

import { CookieBannerExplicit } from './cookie_banner_explicit_base'
import { CookieBannerImplicit } from './cookie_banner_implicit_base'
import { ConsentRegionType, ManageCookiesText, ManageCookiesUrl } from './cookie_banner_utils'
import { CookieBannerVariant } from './types'

import * as styles from './base_cookie_banner.css'

const AuthCookiePersistentMessage = React.memo(function AuthCookiePersistentMessage(props: {
  consentRegion: ConsentRegion
}) {
  let label
  let url
  if (props.consentRegion === 'implicit') {
    label = ManageCookiesText(ConsentRegionType.IMPLICIT)
    url = ManageCookiesUrl(ConsentRegionType.IMPLICIT)
  } else if (props.consentRegion === 'explicit') {
    label = ManageCookiesText(ConsentRegionType.EXPLICIT)
    url = ManageCookiesUrl(ConsentRegionType.EXPLICIT)
  }

  return (
    <div role="region" aria-label={label} className={styles.auth__persistentMessage}>
      <AnchorElementTracked rel="noopener" target="_blank" href={url}>
        {label}
      </AnchorElementTracked>
    </div>
  )
})

export const AuthCookieBanner = React.memo(function AuthCookieBanner() {
  if (initialOptions().consent_region === 'implicit') {
    return (
      <CookieBannerImplicit
        variant={CookieBannerVariant.AUTH}
        dismissIcon={dismissIcon}
        SecondaryButton={(props) => (
          <DEPRECATED_BrandButton
            fullWidth={false}
            className={styles.brandButton__small}
            use="hollow"
            {...props}
          />
        )}
        persistentMessage={<AuthCookiePersistentMessage consentRegion="implicit" />}
      />
    )
  } else if (initialOptions().consent_region === 'explicit') {
    return (
      <CookieBannerExplicit
        variant={CookieBannerVariant.AUTH}
        dismissIcon={dismissIcon}
        PrimaryButton={(props) => (
          <DEPRECATED_BrandButton
            fullWidth={false}
            className={styles.brandButton__small}
            use="standard"
            {...props}
          />
        )}
        SecondaryButton={(props) => (
          <DEPRECATED_BrandButton
            fullWidth={false}
            className={styles.brandButton__small}
            use="hollow"
            {...props}
          />
        )}
        persistentMessage={<AuthCookiePersistentMessage consentRegion="explicit" />}
      />
    )
  }

  return null
})
